const flights = [
  {
    id: 1,
    airline: "IndiGo",
    code: "6E-204",
    from: "Hyderabad",
    fromCode: "HYD",
    to: "Delhi",
    toCode: "DEL",
    departure: "06:15",
    arrival: "08:40",
    duration: "2h 25m",
    price: 4500,
    seats: 12,
    class: "Economy",
    stops: "Non-stop",
    rating: 4.2,
    logo: "✈",
    color: "#6366f1",
  },
  {
    id: 2,
    airline: "Air India",
    code: "AI-505",
    from: "Bangalore",
    fromCode: "BLR",
    to: "Mumbai",
    toCode: "BOM",
    departure: "09:30",
    arrival: "11:15",
    duration: "1h 45m",
    price: 5200,
    seats: 4,
    class: "Economy",
    stops: "Non-stop",
    rating: 4.5,
    logo: "✈",
    color: "#ef4444",
  },
  {
    id: 3,
    airline: "Vistara",
    code: "UK-813",
    from: "Chennai",
    fromCode: "MAA",
    to: "Kolkata",
    toCode: "CCU",
    departure: "11:00",
    arrival: "13:25",
    duration: "2h 25m",
    price: 6100,
    seats: 8,
    class: "Business",
    stops: "Non-stop",
    rating: 4.8,
    logo: "✈",
    color: "#8b5cf6",
  },
  {
    id: 4,
    airline: "Akasa Air",
    code: "QP-1341",
    from: "Pune",
    fromCode: "PNQ",
    to: "Goa",
    toCode: "GOI",
    departure: "14:20",
    arrival: "15:35",
    duration: "1h 15m",
    price: 3900,
    seats: 22,
    class: "Economy",
    stops: "Non-stop",
    rating: 4.0,
    logo: "✈",
    color: "#f97316",
  },
  {
    id: 5,
    airline: "SpiceJet",
    code: "SG-101",
    from: "Delhi",
    fromCode: "DEL",
    to: "Bangalore",
    toCode: "BLR",
    departure: "16:50",
    arrival: "19:30",
    duration: "2h 40m",
    price: 4100,
    seats: 18,
    class: "Economy",
    stops: "Non-stop",
    rating: 3.9,
    logo: "✈",
    color: "#ef4444",
  },
  {
    id: 6,
    airline: "Air India",
    code: "AI-677",
    from: "Mumbai",
    fromCode: "BOM",
    to: "Hyderabad",
    toCode: "HYD",
    departure: "20:10",
    arrival: "21:45",
    duration: "1h 35m",
    price: 4800,
    seats: 6,
    class: "Economy",
    stops: "Non-stop",
    rating: 4.3,
    logo: "✈",
    color: "#ef4444",
  },
];

export default flights;